import { Tabs } from '@mantine/core';
import { useMemo } from 'react';

import classes from './TSDView.module.css';

interface TSDViewTabConfig {
  value: string;
  label: React.ReactNode;
  panel: React.ReactNode | null;
}

interface UseTSDViewTabsProps {
  visibleTabs: TSDViewTabConfig[];
}

export const useTSDViewTabs = ({ visibleTabs }: UseTSDViewTabsProps) => {
  return useMemo(() => {
    return visibleTabs.reduce(
      (acc, tab) => {
        acc.tabItems.push(
          <Tabs.Tab key={tab.value} value={tab.value} data-pw={`${tab.value}-tab`}>
            {tab.label}
          </Tabs.Tab>,
        );

        if (tab.panel) {
          acc.panelItems.push(
            <Tabs.Panel key={tab.value} value={tab.value} className={classes.tabPanel}>
              {tab.panel}
            </Tabs.Panel>,
          );
        }

        return acc;
      },
      { tabItems: [] as React.ReactNode[], panelItems: [] as React.ReactNode[] },
    );
  }, [visibleTabs]);
};
